module.exports = __webpack_public_path__ + "static/media/swipepages.b9f15692.svg";